const faqItems = [
  {
    q: '极速影视是否需要付费观看？',
    a: '极速影视目前所有内容均为免费在线观看，无需任何付费订阅。我们通过平台合作与广告收入维持运营，致力于为用户提供零门槛的高清追剧体验。',
  },
  {
    q: '极速影视的影片多久更新一次？',
    a: '极速影视每日更新，最新电影在院线下线后最快48小时内上线，热播电视剧每日同步更新最新剧集，综艺节目通常在播出后24小时内上线高清版本。',
  },
  {
    q: '为什么有些影片播放时出现缓冲？',
    a: '极速影视采用先进的CDN分发技术，通常情况下高清播放流畅不卡顿。如遇缓冲，建议检查网络连接或切换至较低清晰度。平台持续优化播放技术以提升体验。',
  },
  {
    q: '极速影视支持哪些设备观看？',
    a: '极速影视全面适配电脑、平板和手机浏览器，无需下载额外软件。同时提供iOS和Android客户端下载，支持跨设备追剧进度同步，切换设备无缝衔接。',
  },
  {
    q: '如何向极速影视推荐想看的影片？',
    a: '欢迎通过"联系我们"页面或发送邮件至 contact@jisumovie.com 提交影片推荐，我们的内容团队会定期评估用户需求并优先引进呼声最高的影视资源。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            关于极速影视，你想知道的都在这里
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <details key={i} className="group bg-background-100 rounded-xl overflow-hidden" open>
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-200 flex items-center justify-center group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-foreground-600 text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}